import {Fragment} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {useSuiContext} from '@s-ui/react-context'
import {useGetInsuranceInfoContent} from '@adv-mt/mt-panel-financing/lib/hooks/useGetInsuranceInfoContent.js'
import AlertOutlineIcon from '@adv-mt/mt-svg-icons/lib/AlertOutline.js'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-insuranceInfoDrawer`

const renderLink = ({href, text}) => `<a href="${href}" rel="noreferrer" target="_blank"><strong>${text}</strong></a>`

const InsuranceInfoDrawer = ({onClose, insuranceId}) => {
  const {domain, i18n} = useSuiContext()
  const config = domain.get('config')
  const {INSURANCE_IDS, URL_INSURANCE_INFO_LIFE_PLUS, URL_INSURANCE_INFO_GAP} = config.get('financing')
  const {SANTANDER_WITH_LIFE_INSURANCE} = INSURANCE_IDS

  const {captionText, modalInfo} = useGetInsuranceInfoContent(insuranceId)

  const linkedParagraph = (
    insuranceId === SANTANDER_WITH_LIFE_INSURANCE
      ? [
          i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_LIFE_PLUS'),
          renderLink({
            href: URL_INSURANCE_INFO_LIFE_PLUS,
            text: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_LIFE_PLUS')
          })
        ]
      : [
          i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_1_GAP'),
          renderLink({
            href: URL_INSURANCE_INFO_LIFE_PLUS,
            text: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_1_GAP')
          }),
          i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_TEXT_2_GAP'),
          renderLink({
            href: URL_INSURANCE_INFO_GAP,
            text: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LINK_2_GAP')
          })
        ]
  ).join(' ')

  return (
    <BaseDrawer onClose={onClose} title={captionText}>
      <div className={`${BASE_CLASS}-content`}>
        {modalInfo.map((section, i) => (
          <Fragment key={i}>
            {section.title && <Body2 highlight>{section.title}</Body2>}
            {section.description.map((text, j) => (
              <Body2 key={j}>{text}</Body2>
            ))}
            {section.listTitle && <Body2>{section.listTitle}</Body2>}
            <ul className={`${BASE_CLASS}-list`}>
              {section.itemsList.map(({icon: ItemIcon, title, value}, k) => (
                <li className={`${BASE_CLASS}-listItem`} key={k}>
                  <Icon intent={ICON_INTENTS.PRIMARY} size={ICON_SIZES.MD}>
                    <ItemIcon size={ICON_SIZES.MD} />
                  </Icon>
                  <div className={`${BASE_CLASS}-listItemText`}>
                    <Body2 highlight>{title}</Body2>
                    {value && <Body2>{value}</Body2>}
                  </div>
                </li>
              ))}
            </ul>
            <div className={`${BASE_CLASS}-importantInfo`}>
              <Icon intent={ICON_INTENTS.ALERT} size={ICON_SIZES.MD}>
                <AlertOutlineIcon size={ICON_SIZES.MD} />
              </Icon>
              <div className={`${BASE_CLASS}-importantInfoText`}>
                <Body2 highlight>{section.importantInfoTitle}</Body2>
                {section.importantInfo.map((text, j) => (
                  <Body2 key={j}>{text}</Body2>
                ))}
              </div>
            </div>
          </Fragment>
        ))}

        <Body2 className={`${BASE_CLASS}-link`}>{htmlStringToReactElement(linkedParagraph)}</Body2>
      </div>
    </BaseDrawer>
  )
}

InsuranceInfoDrawer.displayName = 'InsuranceInfoDrawer'

InsuranceInfoDrawer.propTypes = {
  insuranceId: PropTypes.string,
  onClose: PropTypes.func.isRequired
}

export default InsuranceInfoDrawer
